class FarloUiTicketCalendar {
	constructor(element, _config) {
		this.container = element;
		this.options = _config;
		this.minDate = new Date(this.container.dataset.startMonth);
		this.maxDate = new Date(this.container.dataset.endMonth);
		this.startDay = this.container.dataset.startDay === 'monday' ? 1 : 0; // 1 for Monday, 0 for Sunday
		this.currentDate = new Date(this.container.dataset.startMonth);
		this.cache = {};
		this.render();
	}

	renderHeader() {
		const header = document.createElement('div');
		header.classList.add('farlo-ui-ticket-calendar__header');

		const title = document.createElement('h2');
		title.classList.add('farlo-ui-ticket-calendar__header-month-year');
		title.textContent = this.currentDate.toLocaleDateString(undefined, { year: 'numeric', month: 'long' });
		header.appendChild(title);

		const prevButton = document.createElement('button');
		prevButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--prev', 'button');
		prevButton.textContent = '<';

		if (this.currentDate > this.minDate) {
			prevButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
			prevButton.addEventListener('click', () => this.prevMonth());
		} else {
			prevButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
		}

		header.appendChild(prevButton);

		const nextButton = document.createElement('button');
		nextButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--next', 'button');
		nextButton.textContent = '>';

		if (this.currentDate < this.maxDate) {
			nextButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
			nextButton.addEventListener('click', () => this.nextMonth());
		} else {
			nextButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
		}

		header.appendChild(nextButton);
		this.container.appendChild(header);
	}

	renderDaysOfTheWeeks() {
		const div = document.createElement('div');
		div.classList.add('farlo-ui-ticket-calendar__weeks');
		const daysLetters = this.startDay === 1 ? ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'] : ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];

		for (let i = 0; i < 7; i ++) {
			const days = document.createElement('div');
			days.classList.add('farlo-ui-ticket-calendar__week-day');
			days.textContent = daysLetters[ i ];
			div.appendChild(days);
		}

		this.container.appendChild(div);
	}

	async fetchEventsForMonth(y, m) {
		const cacheKey = `${ y }-${ m }`;
		if (this.cache[ cacheKey ]) {
			this.renderCalendar(this.cache[ cacheKey ]);
			return;
		}

		const data = new URLSearchParams({
			action: 'getEventsForMonth',
			nonce: farloAjaxVendorHandler.nonce,
			month: m,
			year: y
		});

		this.container.classList.add('farlo-ui-ticket-calendar--loading');

		try {
			const response = await fetch(farloAjaxVendorHandler.ajaxurl, {
				method: 'POST',
				body: data,
				headers: {
					'Accept': 'application/json',
					'Content-type': 'application/x-www-form-urlencoded',
					'X-WP-Nonce': farloAjaxVendorHandler.nonce
				}
			});

			if (response.ok) {
				const responseData = await response.json();
				this.cache[ cacheKey ] = responseData.data.calendarCells;
				this.cacheMultiMonthData(responseData.data.multiMonthData);
				this.container.classList.remove('farlo-ui-ticket-calendar--loading');
				this.renderCalendar(this.cache[ cacheKey ]);
			} else {
				console.error('Response status not OK:', response.status);
			}
		} catch (error) {
			console.error('There was an error!', error);
		}
	}

	cacheMultiMonthData(multiMonthData) {
		for (const [key, value] of Object.entries(multiMonthData)) {
			if (!this.cache[ key ]) {
				this.cache[ key ] = value;
			}
		}
	}

	renderCalendar(calendarCells) {
		this.container.innerHTML = '';
		this.renderHeader();
		this.renderDaysOfTheWeeks();
		if (calendarCells !== '') {
			this.container.insertAdjacentHTML('beforeend', calendarCells);
		}
	}

	async render() {
		this.container.innerHTML = '';
		this.renderHeader();
		this.renderDaysOfTheWeeks();
		await this.fetchEventsForMonth(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1);
	}

	prevMonth() {
		this.currentDate.setMonth(this.currentDate.getMonth() - 1);
		this.render();
	}

	nextMonth() {
		this.currentDate.setMonth(this.currentDate.getMonth() + 1);
		this.render();
	}

	handleEventClick(event) {
		if (this.options.eventClick) {
			this.options.eventClick(event);
		}
	}
}

export default FarloUiTicketCalendar;
